@if (visible && currentImage) {
  <div class="image-viewer-backdrop" (click)="onBackdropClick($event)">
    <!-- Close button -->
    <button class="iv-btn iv-close" (click)="close()" title="Close (Esc)">
      <i class="ti ti-x"></i>
    </button>

    <!-- Top toolbar -->
    <div class="iv-toolbar">
      <button class="iv-btn" (click)="zoomIn()" title="Zoom in (+)">
        <i class="ti ti-zoom-in"></i>
      </button>
      <button class="iv-btn" (click)="zoomOut()" title="Zoom out (-)">
        <i class="ti ti-zoom-out"></i>
      </button>
      <span class="iv-zoom-label">{{ (zoom * 100) | number:'1.0-0' }}%</span>
      <div class="iv-separator"></div>
      <button class="iv-btn" (click)="rotateLeft()" title="Rotate left">
        <i class="ti ti-rotate-2"></i>
      </button>
      <button class="iv-btn" (click)="rotateRight()" title="Rotate right (R)">
        <i class="ti ti-rotate-clockwise-2"></i>
      </button>
      @if (images.length > 1) {
        <div class="iv-separator"></div>
        <span class="iv-counter">{{ currentIndex + 1 }} / {{ images.length }}</span>
      }
    </div>

    <!-- Navigation arrows -->
    @if (images.length > 1) {
      <button class="iv-nav iv-nav-prev" (click)="prev()" title="Previous">
        <i class="ti ti-chevron-left"></i>
      </button>
      <button class="iv-nav iv-nav-next" (click)="next()" title="Next">
        <i class="ti ti-chevron-right"></i>
      </button>
    }

    <!-- Image -->
    <div class="iv-image-wrap">
      <img
        [src]="currentImage.src"
        [alt]="currentImage.title || 'Preview'"
        [style.transform]="imageTransform"
        [class.iv-draggable]="zoom > 1"
        (mousedown)="onMouseDown($event)"
        (wheel)="onWheel($event)"
        draggable="false"
      />
    </div>

    <!-- Title -->
    @if (currentImage.title) {
      <div class="iv-title">{{ currentImage.title }}</div>
    }
  </div>
}
